import { AiOutlineCheck } from "react-icons/ai";
import { BsDownload } from "react-icons/bs";
import { Spinner } from "react-bootstrap";

import useBuscaAnexo from "../OS/Anexos/hooks/useBuscaAnexo";

const AndamentoOsDetalhamento = ({ data }) => {
  const { baixarAnexo, isLoading } = useBuscaAnexo();

  if (!data?.anexos?.length) {
    return (
      <div className="m-2">
        <span className="m-0 font-weight-bold text-primary flex-grow-1 px-3">Nenhum anexo para este andamento</span>
      </div>
    );
  }

  return (
    <div className="text-left m-4">
      <h5>Anexos</h5>

      {isLoading && (
        <div className="d-flex align-items-center mb-2">
          <Spinner animation="border" size="sm" role="status" className="mr-2" />
          <span style={{ color: "#e37023", fontWeight: 500 }}>Baixando arquivo...</span>
        </div>
      )}

      <ul className="list-group">
        {data.anexos.map((item) => (
          <li className="list-group-item" key={item.item || item.nomeArquivo}>
            <div className="d-flex align-items-center">
              <AiOutlineCheck className="text-success" />
              <span className="ml-2">
                {item.descricao ? `${item.nomeArquivo} -> ${item.descricao}` : item.nomeArquivo}
              </span>
              <button
                type="button"
                className="btn btn-link p-0 ml-2"
                title="Baixar arquivo"
                disabled={isLoading}
                onClick={() => baixarAnexo(data.sqAcaoFiscal, item.item, item.nomeArquivo)}
              >
                <BsDownload size={16} />
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AndamentoOsDetalhamento;
